import styles from './BlockLabel.styl'

// css in js(styled-jsx)で対処
export const BlockLabel = ({name})=>{
  return (
    <>
    <div className="BlockLabel">
      <div className="BlockLabel_inner">{name}</div>
    </div>
    <style jsx="true" scoped>{styles.toString()}</style>
    </>
  )
}